/**
 * Hook: Text-to-speech via WebSpeech API
 */
import { useState } from 'react'

export function useTTS() {
  const [enabled, setEnabled] = useState(false)
  const [speaking, setSpeaking] = useState(false)

  const speak = (text: string) => {
    if (!enabled || !text) { return }
    window.speechSynthesis.cancel()
    const utterance = new SpeechSynthesisUtterance(text)
    utterance.lang = 'en-US'
    utterance.onstart = () => setSpeaking(true)
    utterance.onend = () => setSpeaking(false)
    utterance.onerror = () => setSpeaking(false)
    window.speechSynthesis.speak(utterance)
  }

  const toggle = () => {
    if (speaking) { window.speechSynthesis.cancel(); setSpeaking(false) }
    setEnabled(prev => !prev)
  }

  return { enabled, speaking, speak, toggle }
}
